import React from 'react';

function Spinner(props) {
  return (
    <div className="Icon__spinner">
      <svg version="1.1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
        <defs>
          <linearGradient id="a" y1="108.38%">
            <stop stopColor="#81F3C4" offset="0" />
            <stop stopColor="#D299FF" offset=".46612" />
            <stop stopColor="#FF54B3" offset="1" />
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g transform="translate(8)" fill="url(#a)" fillRule="nonzero">
            <path
              transform="translate(4 4) scale(-1 1) translate(-4 -4)"
              d="m8 0v1.3714c-3.5876 0-6.5096 2.8502-6.625 6.4098l-0.0035431 0.2188h-1.3714c0-4.3394 3.4549-7.8718 7.7641-7.9966l0.23588-0.0034108z"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}

export default Spinner;
